export class DedupeState {
    lastRun: Date;
    seedState: SeedState;
}

export enum SeedState {
    NOT_RUN  = 'NOT_RUN',
    RUNNING  = 'RUNNING',
    COMPLETE = 'COMPLETE'
}
